module.exports = __webpack_public_path__ + "img/about_product_3.7e558223.png";